import { useMemo } from 'react'
import { Table } from '../../components/Table'
import { columns } from '../UserContractCategories/constants'
import { useUserProfileContext } from './Providers/UserProfileContextProvider'
import { PLACEHOLDERS } from '../../constants'
import { Input } from '../../components/Input'
import { ReactComponent as Search16 } from 'assets/svg/Search16.svg'
import { ReactComponent as Close16 } from '../../assets/svg/Clos16.svg'
import './styles.scss'

type Props = {
  userRole: string
  canSeeCommunityLevelCheckboxes: boolean
  canSeeAssignmentStatus: boolean
  simpleViewModeOnly?: boolean
}

export const ContractCategoriesTable = ({
  userRole,
  canSeeCommunityLevelCheckboxes,
  canSeeAssignmentStatus,
  simpleViewModeOnly
}: Props) => {
  const {
    state: { pageInfo, tableData, totalNumber, searchValue, debouncedSearch },
    actions: { handleTableChange, handleChangePageSize, setSearchValue }
  } = useUserProfileContext()

  const tableColumns = useMemo(
    () =>
      userRole
        ? columns({
            role: userRole,
            canManageContractCategories: canSeeAssignmentStatus,
            communityLevelCheckboxesVisible: canSeeCommunityLevelCheckboxes,
            communityLevelCheckboxesEditable: false,
            categoryAssignmentVisible: false,
            hideActions: true,
            userRole,
            simpleViewModeOnly
          })
        : [],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userRole]
  )

  return (
    <div className="user-profile-contract-categories">
      <Input
        className="allow-clear mb-4"
        propsInput={{
          allowClear: { clearIcon: <Close16 /> },
          placeholder: PLACEHOLDERS.SEARCH,
          prefix: <Search16 />,
          value: searchValue,
          onChange: (e) => setSearchValue(e.target.value)
        }}
      />
      <Table
        dataSource={tableData}
        className="user-contract-categories-table"
        columns={tableColumns}
        onChange={handleTableChange}
        onChangePage={handleChangePageSize}
        hasSearchOrFilters={!!debouncedSearch}
        pageSize={pageInfo.pageSize}
        pagination={{
          pageSize: pageInfo.pageSize,
          current: pageInfo.pageNumber,
          total: totalNumber
        }}
      />
    </div>
  )
}
